import { Component, HostListener } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs';
import { FavIconService } from './services/fav-icon.service';

// Rutas donde el footer global NO debe mostrarse
const AUTH_ROUTES = ['/', '/client'];

// Tipos de <input> nativo donde Enter debe disparar Buscar/Agregar/Iniciar Sesión —
// se excluyen los que no son de texto libre (checkbox/radio ya tienen su propio
// significado para Enter/espacio, y file/range/color no aplican).
const TIPOS_INPUT_TEXTO = new Set(['text', 'number', 'email', 'password', 'tel', 'search', 'url', '']);

// Prefijos de texto (en minúscula) que identifican el botón a disparar con Enter.
const PREFIJOS_BOTON_ACCION = ['buscar', 'agregar', 'iniciar sesión', 'iniciar sesion', 'ingresar'];

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'crm-front';
  showFooter = true;

  constructor(private faviconService: FavIconService, private router: Router){
    this.router.events.pipe(
      filter(e => e instanceof NavigationEnd)
    ).subscribe((e: any) => {
      this.showFooter = !AUTH_ROUTES.includes(e.urlAfterRedirects);
    });
  }

  // Enter en cualquier campo de texto de la app dispara el botón "Buscar"/"Agregar"
  // más cercano — sin tener que cablear cada pantalla una por una. Se salta si el
  // evento ya viene con preventDefault (ej. el autocomplete lo usa para confirmar la
  // sugerencia resaltada del desplegable; ahí Enter NO debe además disparar Buscar).
  @HostListener('document:keydown.enter', ['$event'])
  onEnterKeyGlobal(event: Event): void {
    if (event.defaultPrevented) return;

    const target = event.target as HTMLElement | null;
    if (!target || target.tagName !== 'INPUT') return;
    if (!TIPOS_INPUT_TEXTO.has((target as HTMLInputElement).type)) return;

    const boton = this.buscarBotonAccion(target);
    if (boton) {
      event.preventDefault();
      boton.click();
    }
  }

  // Sube por el árbol del DOM desde el input hasta el primer nivel donde aparezca un
  // botón "Buscar"/"Agregar" — así encuentra el de la sección/modal donde realmente
  // se está escribiendo, no el de otra parte de la pantalla que tenga el mismo texto.
  private buscarBotonAccion(origen: HTMLElement): HTMLButtonElement | null {
    let nivel: HTMLElement | null = origen;
    for (let i = 0; i < 12 && nivel; i++) {
      const botones = Array.from(nivel.querySelectorAll('button')) as HTMLButtonElement[];
      const match = botones.find(b => {
        if (b.disabled) return false;
        const texto = (b.textContent ?? '').trim().toLowerCase();
        return PREFIJOS_BOTON_ACCION.some(prefijo => texto.startsWith(prefijo));
      });
      if (match) return match;
      nivel = nivel.parentElement;
    }
    return null;
  }
}
